import { render, staticRenderFns } from "./MoneyBonusEditor.vue?vue&type=template&id=f700f802&"
import script from "./MoneyBonusEditor.vue?vue&type=script&lang=js&"
export * from "./MoneyBonusEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports